import { Component, OnInit } from '@angular/core';
import { environment } from '@lohi/environments/environment';
import { Observable } from 'rxjs';
import { FeatureFlagService } from '../feature-flags.service';

@Component({
  selector: 'lohi-api-indicator',
  templateUrl: './api-indicator.component.html',
  styles: [],
})
export class ApiIndicatorComponent implements OnInit {
  public flagEnv$: Observable<'Stage' | 'Prod'>;
  constructor(public featureFlagService: FeatureFlagService) {}

  public ngOnInit(): void {
    this.flagEnv$ = this.featureFlagService.flagEnvironment$;
  }

  public getEnvName(): string {
    switch (environment.api) {
      case 'https://api.lohi.ai':
        return 'Prod';
      case 'https://stage.api.lohi.ai':
        return 'Stage';
      case 'http://localhost:8080':
      case 'http://localhost:8090':
        return 'Local';
      default:
        return '????';
    }
  }
}
